import React from "react";

export const BtnChiTietNhanVay = ({ item, onOpenModalNhanVay }) => {
  return (
    <>
      <a
        href="#!"
        className="blue btn-link"
        onClick={() => onOpenModalNhanVay(item)}
      >
        {item.MaHopDong}
      </a>
    </>
  );
};
